/* eslint-disable */
import { withStyles } from '@material-ui/core';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import round from 'lodash/round';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import i18nLocaleSelector from '../../State/Store/I18n/Selectors/I18nLocale.selector';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import { UI_EXPANSION_PANEL_COLLAPSED, UI_EXPANSION_PANEL_EXPANDED } from '../../State/Store/UI/UI.types';
import toDisplayUnit from '../../Support/Converters/ToDisplayUnit/ConvertersToDisplayUnit.support';
import generateHash from '../../Support/Generators/GenerateHash/GeneratorsGenerateHash.support';
import isNumber from '../../Support/Is/Number/IsNumber.support';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import I18n from '../I18n/I18n.component';
import OrderConcreteDeliveriesScheduledSectionPropTypes from './OrderConcreteDeliveriesScheduledSection.component.props';
import orderConcreteDeliveriesScheduledSectionStyles from './OrderConcreteDeliveriesScheduledSection.component.styles';

/**
 * OrderConcreteDeliveriesScheduledSectionComponent
 * @export
 * @class OrderConcreteDeliveriesScheduledSectionComponent
 * @extends {React.Component<OrderConcreteDeliveriesScheduledSectionComponentComposedProps, OrderConcreteDeliveriesScheduledSectionComponentState>}
 */
export class OrderConcreteDeliveriesScheduledSectionComponent extends React.Component {
  preserveScrollRef = React.createRef();

  /**
   * The `props` to seed when any specific prop receives an `undefined` value. NOT a `null` value
   * @static
   * @type {Partial<OrderConcreteDeliveriesScheduledSectionComponentProps>}
   * @memberof OrderConcreteDeliveriesScheduledSectionComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`OrderConcreteDeliveriesScheduledSectionComponent`}
   * @memberof OrderConcreteDeliveriesScheduledSectionComponent
   */
  static displayName = `OrderConcreteDeliveriesScheduledSectionComponent`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof OrderConcreteDeliveriesScheduledSectionComponent
   */
  static propTypes = OrderConcreteDeliveriesScheduledSectionPropTypes;

  /**
   * Data specific to the `<OrderConcreteDeliveriesScheduledSectionComponent />` instance
   * @type {OrderConcreteDeliveriesScheduledSectionComponentState}
   * @memberof OrderConcreteDeliveriesScheduledSectionComponent
   */
  state = {
    expanded: false,
  };

  /**
   * Returns the unit of measure
   * @returns {string} The unit of measure
   * @memberof OrderConcreteDeliveriesScheduledSectionComponent
   */
  getUnitOfMeasure = () => {
    const { currentOrder } = this.props;
    const { details } = currentOrder;
    const { qty } = details || {};
    const { uom } = qty || {};
    return toDisplayUnit(uom);
  };

  /**
   * Returns the unit of measure
   * @param {any} event The event
   * @param {boolean} expanded The expanded state
   * @returns {string} The unit of measure
   * @memberof OrderConcreteDeliveriesScheduledSectionComponent
   */
  onExpansionPanelChange = (event, expanded) => {
    const { actions } = this.props;
    const type = expanded ? UI_EXPANSION_PANEL_EXPANDED : UI_EXPANSION_PANEL_COLLAPSED;
    actions.uiTriggered({
      payload: {
        data: {
          name: `OrderConcreteDeliveriesScheduledSection`,
        },
      },
      type,
    });
    this.setState({
      expanded,
    });
  };

  /**
   * Renders the expand icon
   * @returns {React.Component} component
   * @memberof OrderConcreteDeliveriesScheduledSectionComponent
   */
  renderExpandIcon = () => {
    const { expanded } = this.state;
    if (expanded) {
      return <RemoveIcon />;
    }
    return <AddIcon />;
  };

  /**
   * Renders the delivery load item
   * @param {any} load The current load
   * @returns {React.Component} component
   * @memberof OrderConcreteDeliveriesScheduledSectionComponent
   */
  renderLoad = (load) => {
    const {
      classes,
      locale: { lang },
    } = this.props;
    const {
      loadQty,
      reviewedOnJobTime,
      truck: { actualLoadTime, code },
    } = load;
    const isLoading = actualLoadTime.trim().length > 0;
    const isTicketed = code.trim().length > 0;
    const options = { hour: `numeric`, minute: `numeric`, timeZone: `UTC` };
    const etaTime = isNumber(+reviewedOnJobTime) ? new Intl.DateTimeFormat(lang, options).format(new Date(+reviewedOnJobTime)) : `-`;
    const unitOfMeasure = this.getUnitOfMeasure();
    const quantity = `${round(loadQty, 1).toFixed(1)}${unitOfMeasure}`;
    const uniqueKey = generateHash(load);
    return (
      <Grid classes={{ container: classes.detailsItemContainer }} container justify="space-between" key={uniqueKey}>
        <Grid item sm={3} xs>
          <Typography>{etaTime}</Typography>
          <I18n variant="caption">OrderService.ConcreteDeliveries.Labels.Eta</I18n>
        </Grid>
        <Grid item sm={6} xs>
          <I18n data={{ isLoading, quantity }} variant="body2">
            OrderService.ConcreteDeliveries.Labels.Loading
          </I18n>
          {isTicketed && (
            <I18n data={{ code }} variant="caption">
              OrderService.ConcreteDeliveries.Labels.Truck
            </I18n>
          )}
        </Grid>
      </Grid>
    );
  };

  /**
   * Renders the scheduled details section
   * @param {Order} currentDeliveryDetails The current order
   * @returns {React.Component} component
   * @memberof OrderConcreteDeliveriesScheduledSectionComponent
   */
  renderScheduled = (currentDeliveryDetails) => {
    if (!currentDeliveryDetails || !currentDeliveryDetails.data) {
      return null;
    }
    const {
      data: {
        orders: {
          loads: { scheduled },
          orderQty: totalOrdered,
          totalScheduled,
        },
      },
    } = currentDeliveryDetails;
    const unitOfMeasure = this.getUnitOfMeasure();
    const scheduledLoads = scheduled.map(this.renderLoad);
    const { classes } = this.props;
    return (
      <ExpansionPanel classes={{ root: classes.section }} onChange={this.onExpansionPanelChange}>
        <ExpansionPanelSummary classes={{ root: classes.detailsHeader }} expandIcon={parseFloat(totalScheduled) > 0 && this.renderExpandIcon()}>
          <Grid alignItems="center" container justify="space-between" spacing={4}>
            <Grid item sm={3} xs>
              <I18n variant="body1">OrderService.ConcreteDeliveries.Labels.ScheduledHeader</I18n>
            </Grid>
            <Grid item sm={6} xs>
              <Typography>{`${round(totalScheduled, 1).toFixed(1)}${unitOfMeasure} / ${round(totalOrdered, 1).toFixed(1)}${unitOfMeasure}`}</Typography>
            </Grid>
          </Grid>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={classes.noPadding}>
          <div className={classes.detailsContainer}>{scheduledLoads}</div>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    );
  };

  /**
   * Render the component
   * @returns {React.Component} The rendered `<OrderConcreteDeliveriesScheduledSectionComponent />`
   * @memberof OrderConcreteDeliveriesScheduledSectionComponent
   */
  render() {
    const { currentDeliveryDetails } = this.props;
    return this.renderScheduled(currentDeliveryDetails);
  }
}

/** @type {React.ComponentClass<OrderConcreteDeliveriesScheduledSectionProps>} */
const OrderConcreteDeliveriesScheduledSection = compose(
  withStyles(themeCreateInjectableStyles(orderConcreteDeliveriesScheduledSectionStyles), { withTheme: true }),
  connect(
    (state) => ({
      locale: i18nLocaleSelector(state),
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
        },
        dispatch,
      ),
    }),
  ),
)(OrderConcreteDeliveriesScheduledSectionComponent);

export default OrderConcreteDeliveriesScheduledSection;
